module.exports = __webpack_public_path__ + "img/processing.233e9443.png";